//Estilos
import './INAVIHomePage.css';

//Componentes
import UsersWaitingValidationContainer from '../../components/usersWaitingValidation/UsersWaitingValidationContainer';
import DJCEEnEsperaDeFirmaContainer from '../../components/DJCEEnEsperaDeFirma/DJCEEnEsperaDeFirmaContainer';
import SettingsInfoContainer from '../../components/settingsInfo/SettingsInfoContainer';

function INAVIHomePage() {
    return (
        <div className="INAVIHomePage-container">
            <section className="INAVIHomePage-section">
                <SettingsInfoContainer />
            </section>
            <section className="INAVIHomePage-section">
                <h4 className="table-title">
                    Usuarios en espera de habilitación
                </h4>
                <UsersWaitingValidationContainer />
            </section>
            <section className="INAVIHomePage-section">
                <h4 className="table-title">
                    DJCEs en espera de validación INAVI
                </h4>
                <DJCEEnEsperaDeFirmaContainer />
            </section>
        </div>
    );
}

export default INAVIHomePage;
